import { render, staticRenderFns } from "./DeviceManagerCollapsableCard.vue?vue&type=template&id=9bff135e&scoped=true&"
import script from "./DeviceManagerCollapsableCard.vue?vue&type=script&lang=js&"
export * from "./DeviceManagerCollapsableCard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManagerCollapsableCard.vue?vue&type=style&index=0&id=9bff135e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bff135e",
  null
  
)

export default component.exports